angular.module('autoremind.reseller', [])
    .controller('autoremind.reseller.customers.ScreenController', 
// Setup dependencies
['$scope', '$filter', 'logger', 'resellerService', 'userProfile', 'angularMomentConfig',
    function ($scope, $filter, logger, resellerService, userProfile, angularMomentConfig) {
        $scope.viewModel = {};
        $scope.viewModel.customers = [];
        $scope.viewModel.filteredcustomers = [];
        $scope.viewModel.customerTypes = [];
        $scope.viewModel.selectedCustomerType = null;
        $scope.viewModel.searchIntervals = [];
        $scope.viewModel.selectedSearchInterval = null;
        $scope.viewModel.selectedCustomer = null;
        $scope.viewModel.reverseSort = false;
        $scope.viewModel.q = null;
        $scope.viewModel.loadingIndicator = 0;
        userProfile.initalizeViewModel();
        if (!angular.isDefined(userProfile.viewModel.views.reseller)) {
            userProfile.viewModel.views.reseller = {};
        }
        if (!angular.isDefined(userProfile.viewModel.views.reseller.customers)) {
            // This is the first time opening the patients view, so initialize
            userProfile.viewModel.views.reseller.customers = {};
            userProfile.viewModel.views.reseller.customers.fetchState = {
                buttonLabel: $filter('i18n')('_ButtonRefresh_'),
                busy: false,
            };
        }
        // TODO is this the correct way to get users timezone?
        $scope.timezone = angularMomentConfig.timezone;
        // Map shared model to scope for local reference
        $scope.viewModel = userProfile.viewModel.views.reseller.customers;
        /**
         *
         */
        $scope.init = function () {
            logger.debug('Test: ' + $filter('i18n')('_ButtonRefresh_'));
            $scope.getCustomers();
            // ANDREAS: I don't like to hard-code these values. They should come from server
            // TODO Fix by iterate over returned values (however that will only returned status which would be name as well
            $scope.viewModel.customerTypes =
                [
                    { "name": "All", "status": null },
                    { "name": "Sales", "status": "Sales" },
                    { "name": "Waiting For Training", "status": "Waiting For Training" },
                    { "name": "In Trial", "status": "In Trial" },
                    { "name": "Paying Customer", "status": "Paying Customer" },
                    { "name": "Cancelled Subscription", "status": "Cancelled Subscription" },
                    { "name": "Stopped Paying", "status": "Stopped As Paying Customer" },
                    { "name": "Stopped After Trial", "status": "Stopped After Trial" },
                ];
            $scope.viewModel.selectedCustomerType = $scope.viewModel.customerTypes[4];
            // Setup the date interval with time zone.
            var tz = $scope.timezone;
            var now = moment.tz(tz);
            var currentYear = moment.tz([now.year(), 0, 1], tz).valueOf();
            var lastYear = moment.tz([now.year() - 1, 0, 1], tz).valueOf();
            var currentMonth = moment.tz([now.year(), now.month(), 1], tz).valueOf();
            var lastMonth = moment.tz([now.year(), now.month() - 1, 1], tz).valueOf();
            var currentWeek = moment.tz([now.year(), now.month(), now.date() - now.day()], tz);
            var lastWeek = moment.tz([now.year(), now.month(), now.date() - 7 - now.day()], tz);
            $scope.viewModel.searchIntervals = [
                { "name": "Any", "interval": null },
                { "name": "Current Week", "interval": "" + currentWeek },
                { "name": "Last Week", "interval": "" + lastWeek + "," + currentWeek },
                { "name": "Current Month", "interval": "" + currentMonth },
                { "name": "Last Month", "interval": "" + lastMonth + "," + currentMonth },
                { "name": "Year-to-date", "interval": "" + currentYear },
                { "name": "Last Year", "interval": "" + lastYear + "," + currentYear },
            ];
            $scope.viewModel.selectedSearchInterval = $scope.viewModel.searchIntervals[0];
            $scope.orderByField = 'displayDate';
            $scope.viewModel.reverseSort = true;
        };
        $scope.setSortOrder = function (fieldName) {
            if ($scope.orderByField == fieldName) {
                $scope.viewModel.reverseSort = !$scope.viewModel.reverseSort;
            }
            else {
                $scope.orderByField = fieldName;
            }
        };
        /*
         * Helper for the html
         */
        $scope.setCustomerDisplayDateToolTip = function () {
            for (var index in $scope.viewModel.customers) {
                var customer = $scope.viewModel.customers[index];
                var customerStatus = customer.Status;
                customer.dateToolTip = customer.Status;
                if (customerStatus === 'Paying Customer') {
                    customer.dateToolTip = 'First date as paying customer';
                    customer.displayDate = customer.Paying_Date;
                }
                else if (customerStatus === 'In Trial') {
                    customer.dateToolTip = 'Last day of trial';
                    customer.displayDate = customer.Trial_Date;
                }
                else if (customerStatus === 'Stopped As Paying Customer') {
                    customer.dateToolTip = 'Last day of service';
                    customer.displayDate = customer.Stop_Date;
                }
                else {
                    customer.dateToolTip = 'Last time account was modified';
                    // Remove time
                    customer.displayDate = customer.Modified_Time.split(" ")[0];
                }
                customer.displayDateUnixMS = moment.tz(customer.displayDate, $scope.timezone).valueOf();
            }
        };
        /**
         *
         */
        $scope.getCustomers = function () {
            $scope.viewModel.loadingIndicator++;
            resellerService.getCustomers()
                .then(function (customers) {
                $scope.viewModel.customers = customers.customers;
                $scope.setCustomerDisplayDateToolTip();
                if ($scope.viewModel.loadingIndicator > 0)
                    $scope.viewModel.loadingIndicator--;
            }, function (data, status, statusText) {
                // TODO: If error is 403 show message about insufficient permissions (details are in html)
                // TODO: If error is 400 (bad request) then list details (details are in JSON)
                var msg = 'Error getting customers data from server. Error: ' + status + ' ' + data + ' ' + statusText;
                logger.error(msg);
                // TODO set error field on page instead of showing an alert
                // TODO figure out why this is happening during reload of web site
                //dialogs.notify('Note', msg);
            });
        };
        $scope.isPaying = function (status) {
            return status === 'Paying Customer';
        };
        $scope.isStopped = function (status) {
            return status === 'Stopped As Paying Customer';
        };
        $scope.isInTrial = function (status) {
            return status === 'In Trial';
        };
        $scope.isOther = function (status) {
            return !(status === 'Paying Customer' || status === 'Stopped As Paying Customer' || status === 'In Trial');
        };
        // Initialize the controller - especially if the path has parameters
        $scope.init();
    }]).filter('dateInterval', function () {
    return function (items, period) {
        if (typeof items === 'undefined' || items === null) {
            return '';
        }
        if (period == null) {
            return items;
        }
        var interval = period.split(",");
        var beginDate = interval[0];
        var endDate = moment().valueOf();
        if (interval.length > 1 && interval[1]) {
            endDate = interval[1];
        }
        var retn = [];
        // Not considering time zone here since we are on date, 
        // but it could mean a difference when comparing with other systems 
        angular.forEach(items, function (item) {
            var displayDate = item.displayDateUnixMS;
            if ((beginDate <= displayDate && displayDate < endDate)) {
                retn.push(item);
            }
        });
        return retn;
    };
}).filter('statusFilter', function () {
    return function (customers, status) {
        if (status == null) {
            return customers;
        }
        var filtered = [];
        angular.forEach(customers, function (customer) {
            if (customer.Status == status) {
                filtered.push(customer);
            }
        });
        return filtered;
    };
});
//# sourceMappingURL=reseller.customers.controllers.js.map